import React, { useState } from "react";

import { BreakpointSize, IActiveFacet, IFormSchema } from "types";
import { FormBuilder } from "components";
import { i18nService } from "services";
import { useBreakpoint } from "utils";

import { ActiveFacets, FacetsTrigger, MobileFacets } from ".";

interface FacetsProps extends IFormSchema {
  activeFacets?: IActiveFacet[];
  clearAllFacets: () => void;
  mobileTitle?: string;
  nbResults?: number;
  isLoading?: boolean;
}

export const Facets: React.FC<FacetsProps> = ({
  fields,
  defaultValues,
  activeFacets,
  clearAllFacets,
  mobileTitle,
  nbResults,
  isLoading,
}) => {
  const [isMobileOpen, setMobileOpen] = useState(false);
  const { matches: isMobile } = useBreakpoint(BreakpointSize.m);

  const renderFacets = () => (
    <div className="facets">
      {!!activeFacets?.length && (
        <ActiveFacets
          activeFacets={activeFacets}
          clearAllFacets={clearAllFacets}
        />
      )}

      <h2 className="visually-hidden">
        {i18nService.copy["facets.selectFacets"]}
      </h2>
      <FormBuilder
        fields={fields}
        defaultValues={defaultValues}
        onFormSubmit={() => {}} // dummy handler, effects are added onChange of fields
      />
    </div>
  );

  if (isMobile) {
    return (
      <div className="mobile-facets">
        <FacetsTrigger
          nbActiveFacets={activeFacets?.length}
          onClick={() => setMobileOpen(true)}
        />
        {isMobileOpen && (
          <MobileFacets
            renderFacets={renderFacets}
            handleClose={() => setMobileOpen(false)}
            mobileTitle={mobileTitle}
            isLoading={isLoading}
            nbResults={nbResults}
          />
        )}
      </div>
    );
  }

  return <>{renderFacets()}</>;
};
